module.exports = __webpack_public_path__ + "static/media/thankyou_icon.24ca9148.png";